// Copyright (C) Microsoft Corporation. All rights reserved.

import { propagateEmbedParams } from "./PropagateEmbedParams";

document.addEventListener("DOMContentLoaded", propagateEmbedParams);
